import {
  BanknotesIcon,
  HeartIcon,
  LifebuoyIcon,
  CreditCardIcon,
  TrophyIcon,
  Squares2X2Icon,
  CalculatorIcon
} from '@heroicons/react/24/outline';
import { PetPawIcon } from '@/components/icons/PetPawIcon';

import {
  ROLE_ADMIN,
  ROLE_COLLABORATOR_ADMIN,
  ROLE_COLLABORATOR_EDITOR,
  ROLE_COLLABORATOR_VIEWER,
} from '@/contexts/AuthContext';
import type { NavigationItem } from '@/contexts/ModuleNavigationContext';

const expenseRoles = [
  ROLE_ADMIN,
  ROLE_COLLABORATOR_ADMIN,
  ROLE_COLLABORATOR_VIEWER,
  ROLE_COLLABORATOR_EDITOR,
];

export const expensesNavigationItems: NavigationItem[] = [
  {
    name: 'Despesas',
    href: '/expenses',
    icon: Squares2X2Icon,
    exact: true,
    requiredRoles: expenseRoles,
  },
  {
    name: 'Folha',
    href: '/expenses/payroll',
    icon: BanknotesIcon,
    requiredRoles: expenseRoles,
  },
  {
    name: 'Encargos',
    href: '/expenses/charges',
    icon: CalculatorIcon,
    requiredRoles: expenseRoles,
  },
  {
    name: 'Plano de Saúde',
    href: '/expenses/benefits/health-plan',
    icon: HeartIcon,
    requiredRoles: expenseRoles,
  },
  {
    name: 'Auxílio Funeral',
    href: '/expenses/benefits/funeral-assistance',
    icon: LifebuoyIcon,
    requiredRoles: expenseRoles,
  },
  {
    name: 'Vale Alimentação',
    href: '/expenses/benefits/food',
    icon: CreditCardIcon,
    requiredRoles: expenseRoles,
  },
  {
    name: 'Plano Pet',
    href: '/expenses/benefits/pet-plan',
    icon: PetPawIcon,
    requiredRoles: expenseRoles,
  },
  {
    name: 'Promoção de Saúde',
    href: '/expenses/benefits/health-promotion',
    icon: TrophyIcon,
    requiredRoles: expenseRoles,
  },
];
